<template>
  <div class="p-4">
    <el-form :inline="true" size="mini">
      <el-form-item label="选择植物">
        <el-select
          @change="onPlantChange"
          filterable
          v-model="plantId"
          placeholder="请选择植物"
        >
          <el-option
            v-for="item in plantOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <h5 style="color: #fff"><span></span>次元农场-植物</h5>
    <farm-table
      :skin-id="plantId"
      :poster-url="posterUrl"
      :poster-more-url="posterMoreUrl"
      :type="$route?.query?.type"
      class="mt-3"
    />

    <el-form :inline="true" size="mini" class="pt-3 mt-5">
      <el-form-item label="选择小屋">
        <el-select
          @change="onHouseChange"
          filterable
          v-model="houseId"
          placeholder="请选择小屋"
        >
          <el-option
            v-for="item in houseOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <h5 style="color: #fff"><span></span>次元农场-小屋</h5>
    <farm-table
      :skin-id="houseId"
      :poster-url="posterUrl"
      :poster-more-url="posterMoreUrl"
      :type="$route?.query?.type"
      class="mt-3"
    />
  </div>
</template>


<script>
import FarmTable from './farm-table.vue'
import axios from 'axios'

export default {
  components: {
    FarmTable,
  },
  props: {
    project: {
      type: [String, Number],
      default: 57,
    },
    // 表格主数据请求地址
    posterUrl: {
      type: String,
      default: '/report/farm_data/',
    },
    // 「查看更多」分页数据请求地址
    posterMoreUrl: {
      type: String,
      default: '/report/farm_data_more/',
    },
  },

  data() {
    return {
      plantId: '',
      plantOptions: [],
      houseId: '',
      houseOptions: [],
    }
  },

  computed: {
    
  },

  async mounted() {
    this.plantOptions = await this.fetchFarmSceneList(56)
    this.houseOptions = await this.fetchFarmSceneList(57)
    if (this.plantOptions.length) {
      this.plantId = this.plantOptions[0].value
    }
    if (this.houseOptions.length) {
      this.houseId = this.houseOptions[0].value
    }
  },

  methods: {
    async fetchFarmSceneList(sceneType) {
      const { data } = await axios.get('/proj/farm_scene_list/', {
        params: {
          project: this.project,
          scene_type: sceneType,
        },
      })
      return data.map((item) => ({
        value: item.original_scene_id,
        label: item.chinese,
      }))
    },

    onPlantChange(val) {
      // 选择植物后的回调，可按需扩展
    },

    onHouseChange() {
      // 选择小屋后的回调，可按需扩展
    },
  },
}
</script>

<style scoped>
.el-form-item :deep(.el-form-item__label) {
  color: #fff;
}
</style>